import { useUpdateGoalGroupByMutation } from 'shared/hooks/queries/use-update-goal-group-by-mutation';
export const useUpdateGoalGroupBy = () => {
  const { mutate } = useUpdateGoalGroupByMutation();

  return mutate;
};
